module.exports = __webpack_public_path__ + "static/media/oswaldo_aranda_11.eb1ba9d4.jpg";